import { Route } from 'react-router-dom';

import { lazyImport } from 'utils/lazyImport';
/* To override rsuite lib margin , Remove changes after removal of rsuite lib dependency */
import './styles/styles.css';

const { LeaMovementOrderPage } = lazyImport(
  () => import('../LEA.new/LeaMovementOrderPage'),
  'LeaMovementOrderPage'
);
const { LeaPage } = lazyImport(() => import('../LEA.new/pages/LeaPage'), 'LeaPage');

export const leaConfigNewRoutes = (
  <Route path="/">
    {/*<Route index element={<LeaseOrderListPage />} />*/}
    <Route index element={<LeaPage />} />
    <Route path="/:id" element={<LeaMovementOrderPage />} />
  </Route>
);

export const normalizeString = (input: string): string => {
  return input.toLowerCase().replace(/\s+/g, '_');
};
